export default __webpack_public_path__ + "static/media/painting2.01aac2ac.jpeg";